import React from 'react';

export interface SurveyTableConfig {
  columns: string[];
  rows: number;
  mode: 'simple' | 'multi_option';
}

interface PrintSurveyTableProps {
  payload: Record<string, unknown>;
  config: SurveyTableConfig;
  instruction?: string;
}

export function PrintSurveyTable({ payload, config, instruction }: PrintSurveyTableProps) {
  const { columns, rows, mode } = config;
  const lead =
    instruction?.trim() ||
    String(payload.text || '')
      .replace(/\|[^|]+\|/g, '')
      .replace(/\[[^\]]+\]/g, '')
      .trim();

  return (
    <div className="print-survey-table">
      {lead ? <p className="print-survey-table__instruction">{lead}</p> : null}
      {mode === 'multi_option' ? (
        <p className="print-survey-table__hint">Marca con una X la opción que eligió cada compañero.</p>
      ) : null}
      <div className="print-survey-table__wrap">
        <table className="print-survey-table__grid">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column} className="print-survey-table__th">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }, (_, index) => (
              <tr key={index} className="print-survey-table__tr">
                {columns.map((column, colIndex) => (
                  <td key={`${index}-${column}`} className="print-survey-table__td">
                    {colIndex === 0 && /^n/i.test(column) ? (
                      <span className="print-survey-table__row-num">{index + 1}</span>
                    ) : mode === 'multi_option' && colIndex >= 2 ? (
                      <span className="print-survey-table__mark" aria-hidden />
                    ) : colIndex === 1 && mode === 'multi_option' ? (
                      <span className="print-survey-table__cell" aria-hidden />
                    ) : (
                      <span className="print-survey-table__cell" aria-hidden />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
